import * as React from 'react';

import { Filters } from 'shared/types/candidates-search';
import { CandidatesSearchUserPreset } from '../components/candidates-search-user-presets';

export const UserFavoritesPage: React.FC<{}> = () => {
    const filters: Partial<Filters> = { favoritesOnly: true };
    return <CandidatesSearchUserPreset filters={filters} title="Favorites" />;
};
